import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { ITagsParams } from '../../../spacesPlatform/utils/actionParams';

export class AddTagsToMetricsRequest extends Request<ITagsParams, IResult> {
  constructor(ids: string[], tags: string[]) {
    super('addTagsToMetrics', {
      ids: ids,
      tags: tags
    });
  }
}
